import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  PageSubTitle,
  Text,
  DateTime,
  Member,
  Heading
} from 'components/common/Elements/Elements';

import { getInitialsFull } from 'utils/common';

import classes from './AdditionalContent.module.scss';

const AdditionalContent = ({ title, data }) => {
  const { t } = useTranslation(['activity']);
  return (
    <>
      <PageSubTitle
        title={title}
        className={classes.title}
        classNameHeading={classes.heading}
        size={2}
      />
      <div className={classes.info}>
        {data.accountManager && (
          <Member
            member={{
              fullName: data.accountManager,
              initials: getInitialsFull(data.accountManager)
            }}
          />
        )}
        <DateTime date={data.sentimentDate} time />
      </div>
      <div className={classes.children}>
        {data.sentiment && (
          <div className={classes.labelInfoWrap}>
            <Heading>{`${t('activity:sentiment.SENTIMENT')}:`}</Heading>
            <Text type={'p'} size={4} className={classes.message}>
              {data.sentiment}
            </Text>
          </div>
        )}
        {data.comments && (
          <div className={classes.labelInfoWrap}>
            <Heading>{`${t('activity:sentiment.COMMENT')}`}</Heading>
            <Text type={'p'} size={4} className={classes.message}>
              {data.comments}
            </Text>
          </div>
        )}
      </div>
    </>
  );
};

AdditionalContent.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired
};

export default AdditionalContent;
